export const codeMap: Record<string, string> = {
  AFG: 'af',
  ALA: 'ax',
  AGO: 'ao',
  ARM: 'am',
  AUT: 'at',
  BGD: 'bd',
  BLR: 'by',
  BLZ: 'bz',
  BEN: 'bj',
  BIH: 'ba',
  BRN: 'bn',
  BDI: 'bi',
  CPV: 'cv',
  CDN: 'ca',
  RCA: 'cf',
  CAF: 'cf',
  TCD: 'td',
  RCH: 'cl',
  CHL: 'cl',
  CHN: 'cn',
  COK: 'ck',
  DNK: 'dk',
  SLV: 'sv',
  GNQ: 'gq',
  EST: 'ee',
  KAZ: 'kz',
  PAK: 'pk',
  TUR: 'tr',
  TKM: 'tm',
  UKR: 'ua',
  ARE: 'ae'
};
